import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTabletPinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    viewBox="0 0 21 21"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.822 17.938H5.405a1.667 1.667 0 0 1-1.667-1.667v-10a1.667 1.667 0 0 1 1.667-1.667h10a1.667 1.667 0 0 1 1.667 1.667v3.333M13.738 2.938V6.27"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.006 17.205a2.5 2.5 0 1 0-3.535 0q.522.523 1.767 1.566 1.315-1.113 1.768-1.566M16.238 15.438v.008M7.074 2.938V6.27M3.738 9.604h13.334"
    />
  </svg>
);
export default SvgTabletPinIcon;
